import { render, staticRenderFns } from "./InsertTemplateButton.vue?vue&type=template&id=68fef2b2&scoped=true"
import script from "./InsertTemplateButton.vue?vue&type=script&lang=js"
export * from "./InsertTemplateButton.vue?vue&type=script&lang=js"
import style0 from "./InsertTemplateButton.vue?vue&type=style&index=0&id=68fef2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fef2b2",
  null
  
)

export default component.exports